var e=e=>null==e||0===Object.keys(e).length;export{e as isEmpty};
//# sourceMappingURL=is-empty.js.map
